import { FC } from 'react';
import { Box } from '@mui/material';

import { LayoutProps } from './types';
import { Footer } from './footer/footer';
import { Header } from './header/header';

export const Layout: FC<LayoutProps> = ({ children }) => (
    <Box
        sx={{
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100vh',
        }}
    >
        <Header />
        <Box sx={{ flex: 1 }}>{children}</Box>
        <Footer />
    </Box>
);
